import styles from './LoginFormInfluencer.module.css';

import { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { ModalForgotPassword } from '../ModalForgotPassword';
import { FloatVideoCta } from '../../../../components/FloatVideoCta';
import { Card } from '../../../../components/Card';
import { Button } from '../../../../components/Button';
import { Input } from '../../../../components/forms/Input';
import { Notify } from '../../../../components/Notify';

import { useAuth } from '../../../../hooks/useAuth';
import { MaskCPF } from '../../../../utils/mask';
import * as routes from '../../../../constants/Routes';
import { api } from '../../../../server/api';

interface FormValues {
  cpf?: string;
  email: string;
  password: string;
}

export function LoginFormInfluencer() {
  const { signIn, client, isBrokerDomain } = useAuth();
  const navigate = useNavigate();
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>();

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  const loginByCpf = async (data: FormValues) => {
    try {
      const parameters = {
        searchFunctionality: 'checkCpfBeforeEmail',
        userType: 'player',
        clientId: client.id,
        cpf: data.cpf,
      };

      const response = await api.post('/search', parameters);

      if (response.data.success) {
        const email = response.data.data[0].email;

        data.email = email;
        await loginByEmail(data);
      } else {
        return Notify(
          `Não encontramos o player com o email inserido!`,
          'error'
        );
      }
    } catch (error) {
      console.log('error loginByCpf', error);
      Notify(`Não encontramos o player com o email inserido!`, 'error');
    }
  };

  const loginByEmail = async (data: FormValues) => {
    try {
      await signIn({
        email: data.email,
        password: data.password,
        clientId: client.id,
      });

      navigate(routes.HOME);
    } catch (error) {
      console.log('onSubmit error', error);

      let errorMsg = '';
      if (error.message === 'auth/wrong-password') {
        errorMsg = 'E-mail ou senha incorretos.';
      } else if (
        error.message === 'auth/account-exists-with-different-credential'
      ) {
        errorMsg = 'Já existe uma conta com o e-mail informado.';
      } else if (
        error.message ===
        'Você não está autorizado a fazer login nesse momento. Contate o administrador para mais informações.'
      ) {
        errorMsg = 'E-mail não cadastrado para este cliente.';
      } else {
        errorMsg = 'E-mail ou senha incorretos.';
      }

      Notify(errorMsg, 'error');
    }
  };

  const handleForm = handleSubmit(async (data) => {
    if (client.loginEmail === 'false') {
      await loginByCpf(data);
    } else {
      await loginByEmail(data);
    }
  });

  const onHandleRegister = () => {
    navigate(routes.REGISTER);
  };

  const renderInactiveClient = () => {
    return (
      <div className={styles.inactiveBox}>
        <i className={`material-icons-outlined ${styles.iconLogo}`}>
          domain_disabled
        </i>
        <p>Cliente inativo</p>
        <a href="https://oqdigital.com" className={styles.btnInactiveOutlined}>
          <i className="material-icons-outlined">arrow_back</i>
          Voltar ao site
        </a>
      </div>
    );
  };

  const renderFormInfluencer = () => {
    return (
      <>
        {/* <div className={styles.contentLogoInfluencer}>
          <img
            className={styles.logoInfluencer}
            src={client && client.favIcon}
            alt=""
          />
        </div> */}
        <form onSubmit={handleForm}>
          <div className="m-3">
            <Card shadow={true} isLarge={true}>
              {client.loginEmail === 'false' ? (
                <div className="mb-3">
                  <Input
                    type="text"
                    placeholder="CPF"
                    label="CPF"
                    maxLength={14}
                    errors={errors.cpf ? 'Campo de cpf obrigatório' : ''}
                    {...register('cpf', {
                      required: true,
                      pattern: {
                        value:
                          /([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})/i,
                        message: 'CPF inválido.',
                      },
                    })}
                    onChange={(event) => {
                      const { value } = event.target;
                      event.target.value = MaskCPF(value);
                    }}
                    aria-invalid={errors.cpf ? 'true' : 'false'}
                  />
                </div>
              ) : (
                <>
                  <div className="mb-3">
                    <Input
                      type="text"
                      placeholder="E-mail cadastrado"
                      errors={errors.email ? 'Campo de email obrigatório' : ''}
                      {...register('email', {
                        required: true,
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: 'invalid email address',
                        },
                      })}
                      aria-invalid={errors.email ? 'true' : 'false'}
                    />
                  </div>
                  <div className="mb-3">
                    <Input
                      type="password"
                      placeholder="Senha"
                      errors={errors.password ? 'Campo obrigatório' : ''}
                      {...register('password', {
                        required: true,
                      })}
                      aria-invalid={errors.password ? 'true' : 'false'}
                    />
                  </div>
                </>
              )}
              <div className="d-grid">
                <Button
                  text={isSubmitting ? 'Entrando' : 'Entrar'}
                  icon="person"
                  type="submit"
                  color="primary"
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
                />
              </div>
              <div className="mt-3">
                <div className="d-grid">
                  <Button
                    onClick={(e) => {
                      e.preventDefault();
                      toggleModal();
                    }}
                    text="Esqueceu a senha?"
                    icon="password"
                  />
                </div>
              </div>
              <div className="mt-3">
                <div className="d-grid">
                  <span className="text-center fw-semibold mb-1 tiny-text">
                    É novo por aqui?
                  </span>
                </div>
                <div className="d-grid">
                  <Button
                    onClick={onHandleRegister}
                    text="Cadastre-se"
                    icon="person"
                    type="button"
                    color="flat"
                    disabled={isSubmitting}
                  />
                </div>
              </div>
            </Card>
          </div>
        </form>
      </>
    );
  };

  const desktopBackgroundImage =
    isBrokerDomain && client.backgroundBrokersDesktop
      ? client.backgroundBrokersDesktop
      : client.loginImage;

  const mobileBackgroundImage =
    isBrokerDomain && client.backgroundBrokersMobile
      ? client.backgroundBrokersMobile
      : client && client.loginImageMobile
        ? client.loginImageMobile
        : client.loginImage;

  return (
    <div
      style={{
        background: isMobile ? '' : `url(${desktopBackgroundImage})`,
      }}
      className={`${styles.contentFull} ${styles.backgroundImage}`}
    >
      {client && client.urlVideoLogin && (
        <FloatVideoCta videoUrl={client.urlVideoLogin} />
      )}
      <div className={styles.contentLeft}>
        {isMobile && <img className="img-fluid" src={mobileBackgroundImage} />}
      </div>
      <div className={styles.contentRight}>
        <div className={styles.centeredAllFlex}>
          {client && client.active
            ? renderFormInfluencer()
            : renderInactiveClient()}
        </div>
      </div>
      <ModalForgotPassword
        clientId={client.id}
        modalIsOpen={modalIsOpen}
        toggleModal={toggleModal}
      />
    </div>
  );
}
